var _a;
const initBlockHero = () => {
};
document.addEventListener('DOMContentLoaded', initBlockHero, false);
if (window['acf']) {
    (_a = window['acf']) === null || _a === void 0 ? void 0 : _a.addAction('render_block_preview', initBlockHero);
}
export {};
